import React from 'react';

import { cn } from '@epoch-ui/lib/utils';
import { LinkButton } from '@epoch-ui/components/LinkButton';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';

import { EventBudgetInput } from '../components/EventBudgetInput';

export const ReportingSettingsSection = (): React.ReactElement => {
  const event = useEditableEvent();
  const isCancelled = !!event.scheduledDeletionAt;

  return (
    <div>
      <div
        className={cn('tw-flex tw-items-start tw-justify-between', isCancelled && 'tw-opacity-40')}
      >
        <div>
          <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Reporting</h2>
        </div>
      </div>

      {/* Estimated spend section */}
      <div className="tw-mt-5 tw-space-y-2">
        <div className={cn(isCancelled && 'tw-opacity-40')}>
          <h3 className="tw-m-0 tw-text-sm tw-font-medium tw-leading-4">Estimated spend</h3>
          <p className="tw-m-0 tw-mt-1 tw-text-xs tw-font-normal tw-leading-4 tw-text-primary-grey">
            Guests won&apos;t see this—it&apos;s used to track spend in{' '}
            <LinkButton
              href="https://help.epochapp.com/articles/insights-dashboard-overview"
              target="_blank"
              rel="noopener noreferrer"
              variant="link"
              size="sm"
              className="hover:tw-text-primary-dark tw-h-auto tw-p-0 tw-text-xs tw-font-normal tw-text-primary-grey"
            >
              Insights
            </LinkButton>
          </p>
        </div>

        {/* Input field */}
        <div className="tw-relative tw-max-w-xs">
          <div className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-transform tw-text-primary-grey">
            $
          </div>
          <EventBudgetInput />
        </div>
      </div>
    </div>
  );
};
